import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";

export const EmailThreadCard = ({
  thread,
  selected,
  handleSelect,
  togglePersonalMeta,
  setPersonalMeta,
  isMetaPending,
}) => {
  // TODO if we ever have multiple sources for the threads this
  // will have to be smarter
  let source = (thread.sources || []).find(
    (item) =>
      String(item?.ota || "")
        .trim()
        .toLowerCase() === "email_engine",
  );

  // console.log("Source:", source);

  let participants = source.participants;
  let last_msg = thread.last_msg;
  let sender = participants.find((p) => p.id === thread.last_msg_sender_id);
  let guestName = sender.name;
  let pmsId = (() => {
    let reservations = participants.map((p) => {
      let reservations = p.connections
        .filter((c) => c.connection_type === "guest_reservation")
        .map((c) => c.reservation)
        .filter((c) => !!c);
    });

    // console.log(reservations);

    return "PMS ID";
  })();

  const metaValues = thread.meta_values || [];
  const isUnread = metaValues.indexOf("unread") >= 0;
  const readPending = isMetaPending(thread.id, "unread");
  const priorityPending = isMetaPending(thread.id, "priority");
  const archivePending = isMetaPending(thread.id, "archived");

  return (
    <div
      className={classnames("chat-guest-contact-wrapper", {
        "active-chat-guest-contact": selected,
        "thread-unread": isUnread,
      })}
      key={thread.id}
    >
      <div
        className="message-text-group"
        onClick={() => {
          handleSelect(thread.id);
        }}
      >
        <span
          className="message-text-group-icon"
          uk-tooltip={`title: ${
            thread.contact_category
              ?.toLowerCase()
              .replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"
          }; pos: bottom-left; cls: uk-active contact-tooltip`}
        >
          <Image src="/images/guest-active.svg" />
          <FeatherIcon
            name="mail"
            className="mail-icon"
            style={{ maxWidth: "85%" }}
          />
        </span>

        <div>
          <div className="semi-bold-font">{guestName}</div>
          <div
            className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom"
            uk-tooltip={pmsId}
          >
            {pmsId.length > 30 ? pmsId.slice(0, 30) : pmsId}
          </div>

          <div
            className={
              isUnread ? "chat-guest-unread-message" : "chat-guest-message"
            }
          >
            {last_msg?.length > 60 ? `${last_msg.slice(0, 60)}...` : last_msg}
          </div>
          <div>
            {metaValues.indexOf("unhandled") === -1 && (
              <span
                className="chat-guest-handled"
                aria-label="Handled"
                uk-tooltip="Handled"
              >
                <FeatherIcon
                  name="check"
                  className="handled-icon"
                  color="#28a745"
                />
              </span>
            )}
          </div>
          <div className="chat-guest-contact-date">
            {moment
              .utc(thread.last_message_on)
              .local()
              .format("MMM DD, YYYY hh:mm a")}
          </div>
        </div>
      </div>
      <div className="messages-btn-group">
        <button
          type="button"
          className="uk-button hms-simple-icon-btn inbox-read-state-indicator"
          onClick={() => setPersonalMeta(thread.id, "unread", !isUnread)}
          disabled={readPending}
          aria-busy={readPending}
          uk-tooltip={isUnread ? "Mark as Read" : "Mark as Unread"}
        >
          {readPending ? (
            <span uk-spinner="ratio: 0.6" aria-label="Updating read status" />
          ) : isUnread ? (
            <FeatherIcon
              name="eye-off"
              className="inbox-action-icon inbox-read-state-icon"
              color="inherit"
            />
          ) : (
            <FeatherIcon
              name="eye"
              className="inbox-action-icon inbox-read-state-icon"
              color="inherit"
            />
          )}
        </button>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-priority":
              thread.meta_values.indexOf("priority") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "priority", true)}
          disabled={priorityPending}
          aria-busy={priorityPending}
          uk-tooltip={
            thread.meta_values.indexOf("priority") >= 0
              ? "Unprioritize"
              : "Prioritize"
          }
        >
          {priorityPending ? (
            <span uk-spinner="ratio: 0.6" aria-label="Updating priority" />
          ) : (
            <FeatherIcon
              name="flag"
              className="inbox-action-icon"
              color="inherit"
            />
          )}
        </button>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-archived":
              thread.meta_values.indexOf("archived") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "archived")}
          disabled={archivePending}
          aria-busy={archivePending}
          uk-tooltip={
            thread.meta_values.indexOf("archived") >= 0
              ? "Unarchive"
              : "Archive"
          }
        >
          {archivePending ? (
            <span
              uk-spinner="ratio: 0.6"
              aria-label="Updating archive status"
            />
          ) : (
            <FeatherIcon
              name="archive"
              className="inbox-action-icon"
              color="inherit"
            />
          )}
        </button>
      </div>
    </div>
  );
};
